module.exports = __webpack_public_path__ + "img/full1-min.fcfc1edf.png";